import { jsx as i } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import p from "../../utils/classNames.js";
const d = c((a, o) => {
  const { className: r, children: e, ...s } = a, t = p("ApplicationLayoutHeader", r);
  return /* @__PURE__ */ i("div", { ref: o, ...s, className: t, id: "ApplicationLayoutHeader", children: e });
});
export {
  d as default
};
//# sourceMappingURL=ApplicationLayoutHeader.js.map
